export * from './store';
export * from './authHeader';

export const formatDate = (date) => {
  date = new Date(date);
  const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
  return [
    date.getDate().toString().padStart(2, '0'),
    months[date.getMonth()],
    date.getFullYear(),
  ].join('-');
}